import {
  createContext,
  useContext,
  useRef,
  type MutableRefObject,
  type ReactNode,
} from 'react';

export type PlayerFramingMetrics = {
  /** Camera-to-target distance from the last successful auto-fit pose. */
  distance: number;
  /** World-space bounding sphere radius used for framing (padded box). */
  sphereRadius: number;
};

const PlayerFramingMetricsContext =
  createContext<MutableRefObject<PlayerFramingMetrics> | null>(null);

export function PlayerFramingMetricsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const metricsRef = useRef<PlayerFramingMetrics>({
    distance: 10,
    sphereRadius: 1,
  });

  return (
    <PlayerFramingMetricsContext.Provider value={metricsRef}>
      {children}
    </PlayerFramingMetricsContext.Provider>
  );
}

export function usePlayerFramingMetricsRef(): MutableRefObject<PlayerFramingMetrics> | null {
  return useContext(PlayerFramingMetricsContext);
}
